module.exports = __webpack_public_path__ + "static/OP0-0b45c4e1f6c535886d2bb6de25b32792.png";